import { alpha } from "@mui/material";

const useStyles = (theme, fullScreem) => ({
  stackOption: {
    flexDirection: "row",
    width: "100%",
    p: "5px",
    alignItems: "center",
  },
  textoLimitado: {
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limita o texto a 2 linhas
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  text: {
    fontSize: "0.875rem",
    color: theme.palette.color.text,
  },
  buttonRoter: {
    padding: "10px",
    width: "50%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  },

  textButtonRoter: { textTransform: "none", fontSize: "0.9rem" },
  buttonBottom: {
    width: "33%",
    textTransform: "none",
  },
  paper: {
    borderRadius: "0px",
    height: "calc(100vh-65px)",
    position: "sticky",
    width: "340px!important",
    backgroundColor: theme.palette.background.sideBar,
  },
  header: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    gap: 2,
    p: "15px",
  },
  container: {
    height: "auto",
    overflow: "auto",
    paddingRight: "5px",
    gap: 1.5,
  },
  drawer: {
    position: "absolute",

    clipPath: "none",
    marginTop: "65px",
    flexShrink: 0,
    overflow: "visible",
    "& .MuiDrawer-paper": {
      //zIndex: 1202,
      //boxShadow: "0px 0px 10px  #0000001a",
      borderRadius: "7px",
      color: theme.palette.text.primary,
      mr: "10px",
      height: fullScreem ? "calc(100vh - 20px)" : "calc(100vh - 85px)",
      width: "380px",
      padding: "10px 10px",
      marginTop: fullScreem ? "10px" : "75px",
      overflow: "visible",
      backgroundColor: theme.palette.background.sideBar,
      border: "1px solid " + theme.palette.color.appBarBorder,
      display: "flex",
      gap: 2,
    },
  },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.shadow,
  },
});
export default useStyles;
